import { render, staticRenderFns } from "./function_box.vue?vue&type=template&id=f5496440&scoped=true"
import script from "./function_box.vue?vue&type=script&lang=js"
export * from "./function_box.vue?vue&type=script&lang=js"
import style0 from "./function_box.vue?vue&type=style&index=0&id=f5496440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5496440",
  null
  
)

export default component.exports